import SingleSelect from './Question/SingleSelect';
import NumberText from './Question/NumberText';

export const HOSAssessmentQuestionType = {
  SINGLESELECT: 'SINGLESELECT',
  NUMBERTEXT: 'NUMBERTEXT',
};

export const HOSQuestionMap = {
  [HOSAssessmentQuestionType.SINGLESELECT]: SingleSelect,
  [HOSAssessmentQuestionType.NUMBERTEXT]: NumberText,
};
